module.exports = __webpack_public_path__ + "img/img-illust-disease.0caec049.svg";